import { EntiteValidatorComponent } from './../../../../contents/components/entite-validator/entite-validator.component';
import { EntiteSelectComponent } from './../../../../contents/components/entite-select/components/entite-select.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { of, Observable, BehaviorSubject, Subject } from 'rxjs';
import { EntiteSMALLid } from 'src/app/components/entite/store/entite.model';

import { Store } from '@ngrx/store';
import { OperationId } from 'src/app/components/operation/store/operation.model';
import { OperationState } from 'src/app/components/operation/store/operation.reducer';
import * as fromOperationAction from 'src/app/components/operation/store/operation.actions';
import * as fromOperationSelector from 'src/app/components/operation/store/operation.selectors';

@Component({
  selector: 'app-operation-entites-filters',
  template: `
    <nz-row
      nzAlign="middle"
      nzGutter="4"
      nzJustify="center"
      *ngIf="operation$ | async as operation"
    >
      <nz-col nzSpan="6" class="filterTitle">
        <nz-badge [nzCount]="entites$ | async | size" [nzOffset]="[10, 0]">
          <h4 nz-typography [ngStyle]="{ color: buttonColor }">
            {{ operation?.type | operationType: 'entite' }}
          </h4>
        </nz-badge>
      </nz-col>
      <nz-col nzSpan="14" class="inputSearch">
        <input
          nz-input
          [(ngModel)]="inputModel"
          (ngModelChange)="onSeach($event, operation)"
          nzBorderless
          placeholder="Rechercher une entité..."
        />
      </nz-col>

      <nz-col nzSpan="1"> </nz-col>
      <nz-col nzSpan="1">
        <button
          nz-button
          nzShape="circle"
          nzType="text"
          nz-tooltip
          nzTooltipTitle="Filter les entités"
          nzTooltipPlacement="bottom"
          [nzTooltipMouseEnterDelay]="0.5"
          nzTooltipPlacement="bottom"
        >
          <i nz-icon nzType="filter"></i>
        </button>
      </nz-col>
      <nz-col nzSpan="2">
        <button nz-button nzType="text" nzShape="circle">
          <mat-icon>more_vert</mat-icon>
        </button>
      </nz-col>
    </nz-row>
  `,
  styles: [
    `
      .filterTitle {
        display: flex;
        flex-direction: row;
        justify-content: center;
        justify-items: center;
        margin-top: 10px;
      }

      .addBtn {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        justify-items: flex-end;
        margin-top: -10px;
      }

      .btnFilter {
        margin-top: -10px;
      }

      .inputSearch {
        border-radius: 12px;
        background-color: #f5f5f5;
      }
    `,
  ],
})
export class OperationEntitesFiltersComponent implements OnInit, OnDestroy {
  buttonColor: string = '#062949';
  modalWidth: number = 750;
  subscribe = new Subject();
  inputSearch$ = new BehaviorSubject<string>('');
  inputModel: string = '';

  @Input() operation$: Observable<OperationId | any> = of();
  @Input() entites$: Observable<any> = of(null);
  constructor(
    private operationStore: Store<OperationState>,
    private modal: NzModalService,
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit(): void {}
  ngOnDestroy(): void {
    this.subscribe.next(null);
    this.subscribe.complete();
  }

  onNewEntiteForm(operation: OperationId): void {
    const modal = this.modal.create({
      nzContent: EntiteSelectComponent,
      nzViewContainerRef: this.viewContainerRef,
      nzWidth: this.modalWidth,
      nzFooter: [],
      nzTitle: `Nouvelle entité au projet ${operation.denomination}`,
      nzComponentParams: {},
      nzCloseIcon: '',
      nzClosable: false,
      nzStyle: { top: '20px' },
    });
    const instance = modal.getContentComponent();
    instance.cancel.subscribe((event: any): any => {
      if (!event) {
        return null;
      } else {
        modal.close();
      }
    });
    instance.select.subscribe((entite: EntiteSMALLid): any => {
      if (!entite) {
        return null;
      } else {
        modal.close();
        this.onType(entite, operation);
      }
    });
  }

  onType(entite: EntiteSMALLid, operation: OperationId): void {
    const modal = this.modal.create({
      nzContent: EntiteValidatorComponent,
      nzViewContainerRef: this.viewContainerRef,
      nzWidth: this.modalWidth,
      nzFooter: [],
      nzTitle: `Type d'intervention de ${entite.etablissement?.denomination}`,
      nzComponentParams: {},
      nzCloseIcon: '',
      nzClosable: false,
      nzStyle: { top: '20px' },
    });
    const instance = modal.getContentComponent();
    instance.cancel.subscribe((event: any): any => {
      if (!event) {
        return null;
      } else {
        modal.close();
      }
    });
    instance.validate.subscribe((intervention: any): any => {
      if (!intervention) {
        return null;
      } else {
        modal.close();
        this.onAdd(entite, intervention, operation);
      }
    });
  }

  onAdd(
    entite: EntiteSMALLid,
    intervention: any,
    operation: OperationId
  ): void {
    this.operationStore.dispatch(
      fromOperationAction.addEntiteOperation({
        operation,
        entite,
        intervention,
      })
    );
  }

  onSeach(event: string, operation: OperationId): void {
    // if (!event) {
    //   this.moduleStore.dispatch(
    //     fromModuleAction.loadModules({ operationId: operation.id })
    //   );
    //   return;
    // } else {
    //   const filter = {
    //     operationId: operation.id,
    //     event: event,
    //     type: 'title',
    //   };
    //   this.moduleStore.dispatch(fromModuleAction.queryModules({ filter }));
    // }
  }

  onClearMdole(): void {}
}
